import * as API from '@/utils/request';

export default {
	uiConfig: (params) => API.GET('/adm_arena/v4/ui', params),
};
